import { useState } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import type { EvvSeverity } from '../../scheduling/dashboard/types';
import { getScheduleDashboardOptions } from '@generated';
import { KpiCard } from '~/shared/components/KpiCard';
import { Button } from '~/shared/components/buttons/Button';
import { FilterBar } from '~/shared/components/filter-bar/FilterBar';
import { EvvExceptionTable } from './EvvExceptionTable';

export function EvvCompliance() {
	const [filterStatus, setFilterStatus] = useState<'All' | 'Pending' | 'Resolved' | 'Disputed'>('All');
	const [filterSeverity, setFilterSeverity] = useState<'All' | EvvSeverity>('All');
	const { data: scheduleKpi } = useSuspenseQuery(getScheduleDashboardOptions());

	return (
		<div className="space-y-6 p-4">
			<div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
				<KpiCard
					label="Total Exceptions"
					value={scheduleKpi.evvExceptionTotalRolling7Days}
					subLabel="All exceptions"
					valueClassName="text-gray-700"
					className="border-l-gray-300"
				/>
				<KpiCard
					label="Pending Review"
					value={scheduleKpi.evvExceptionPendingTotal}
					subLabel="Pending Status"
					valueClassName={scheduleKpi.evvExceptionPendingTotal > 0 ? 'text-yellow-700' : 'text-gray-500'}
					className="border-l-yellow-700"
				/>
				<KpiCard
					label="Critical"
					value={scheduleKpi.evvExceptionPendingCriticalTotal}
					subLabel="Require immediate action"
					valueClassName={scheduleKpi.evvExceptionPendingCriticalTotal > 0 ? 'text-red-600' : 'text-gray-500'}
					className="border-l-red-600"
				/>
				<KpiCard
					label="Compliance Rate"
					value={`${scheduleKpi.evvCompliancePercentRolling7Days}%`}
					subLabel="Visits with no exceptions"
					valueClassName={scheduleKpi.evvCompliancePercentRolling7Days >= 90 ? 'text-primary-500' : 'text-yellow-700'}
					className={scheduleKpi.evvCompliancePercentRolling7Days >= 90 ? 'border-l-primary-500' : 'border-l-yellow-700'}
				/>
			</div>
			{/* 
			{exceptionTypes.length > 0 && (
				<div className="rounded-lg border border-gray-200 bg-white p-4">
					<h3 className="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-600">Exception Types</h3>
					<div className="flex flex-wrap gap-2">
						{exceptionTypes.map(type => {
							const count = exceptions.filter(e => e.exceptionType === type).length;
							const pendingOfType = exceptions.filter(e => e.exceptionType === type && e.status === 'Pending').length;
							return (
								<div key={type} className="flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2">
									<span className="text-xs font-medium text-gray-700">{type}</span>
									<span className="text-xs font-bold text-gray-800">{count}</span>
									{pendingOfType > 0 && (
										<span className="rounded-full bg-apricotYogurt px-1.5 py-0.5 text-[10px] font-bold text-mustard">
											{pendingOfType}
										</span>
									)}
								</div>
							);
						})}
					</div>
				</div>
			)} */}

			<div className="space-y-3">
				<FilterBar>
					{(['All', 'Pending', 'Resolved', 'Disputed'] as const).map(s => (
						<Button
							key={s}
							onClick={() => setFilterStatus(s)}
							intent={filterStatus === s ? 'primary' : 'neutral'}
							appearance={filterStatus === s ? 'solid' : 'subtle'}
							size="chipRounded"
							label={s}
						/>
					))}
					<div className="mx-1 h-4 w-px bg-gray-200" />
					{(['All', 'Critical', 'Warning', 'Info'] as const).map(s => (
						<Button
							key={s}
							onClick={() => setFilterSeverity(s)}
							intent={filterSeverity === s ? 'primary' : 'neutral'}
							appearance={filterSeverity === s ? 'solid' : 'subtle'}
							size="chipRounded"
							label={s}
						/>
					))}
				</FilterBar>
				<EvvExceptionTable />
			</div>
		</div>
	);
}
